import { onMounted, onBeforeUnmount } from 'vue'

export function useRefreshGuard(isActive: () => boolean) {
  function handleBeforeUnload(event: BeforeUnloadEvent) {
    if (!isActive()) return

    // Prevent default triggers the native browser dialog
    event.preventDefault()
    // Legacy support (Chrome < 119, some mobile browsers still require this)
    event.returnValue = ''
  }

  onMounted(() => {
    window.addEventListener('beforeunload', handleBeforeUnload)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload)
  })
}
